module.exports = __webpack_public_path__ + "img/game-bg.eb084b9c.png";